import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import { useAuth } from "../../context/AuthContext";
import { capitalizeFirstLetter } from "../../utils/stringFunctions";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useNavigate } from "react-router-dom";
import EditEmail from "./EditEmail";
import EditName from "./EditName";
import EditPhone from "./EditPhone";
import EditPassword from "./EditPassword";
import { multiFactor, MultiFactorInfo, User } from "firebase/auth";
import { MultiFactorSession, PhoneMultiFactorGenerator, PhoneAuthProvider, updateEmail } from "firebase/auth";
import { phoneAuthProvider } from "../../firebase/firebase";

const AccountSettings = () => {
  const authContext = useAuth();
  const auth = authContext?.auth;
  const [editName, setEditName] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [editPhone, setEditPhone] = useState(false);
  const [maskedPhone, setMaskedPhone] = useState("");

  useEffect(() => {
    const updateMultifactor = async (user: User) => {
      if (user) {
        const mfaUsr = await multiFactor(user);
        if (mfaUsr.enrolledFactors) {
          // Get the user's multi-factor info
          const factors = mfaUsr.enrolledFactors as MultiFactorInfo[];
          const phoneFactor = factors.find(factor => factor.factorId === "phone"); // Find the phone factor

          if (phoneFactor && "phoneNumber" in phoneFactor) {
            // Mask the phone number, showing only the last 4 digits

            const phoneNumber = phoneFactor.phoneNumber as string;
            const masked = phoneNumber.replace(/.(?=.{3})/g, "*");
            setMaskedPhone(masked);
          }
        }
      }
    };
    const user = auth?.currentUser;
    user && updateMultifactor(user);
  }, []);

  // const sendVerificationCode = async () => {
  //   try {
  //     const session = await getMultiFactorSession(auth.currentUser!);
  //     if (session && phoneFactorUid) {
  //       // Send the OTP using the PhoneMultiFactorGenerator
  //       const verificationId = await phoneAuthProvider.verifyPhoneNumber(
  //         {
  //           multiFactorHint: { uid: phoneFactorUid }, // Use the UID from the enrolled phone factor
  //           session: session,
  //         },
  //         auth.currentUser!
  //       );
  //       setVerificationId(verificationId);
  //       setStep(2); // Move to the next step (enter OTP)
  //       console.log("Verification code sent to the enrolled phone factor");
  //     }
  //   } catch (error) {
  //     console.error("Error sending verification code:", error);
  //   }
  // };

  return (
    <div className="p-1 bg-white">
      {editEmail && (
        <EditEmail
          close={() => {
            setEditEmail(false);
          }}
        />
      )}
      {editName && (
        <EditName
          close={() => {
            setEditName(false);
          }}
        />
      )}
      {editPhone && (
        <EditPhone
          close={() => {
            setEditPhone(false);
          }}
        />
      )}
      {editPassword && (
        <EditPassword
          close={() => {
            setEditPassword(false);
          }}
        />
      )}
      <ContainerNavigation
        backArrow={false}
        title="Account Settings"
        subtitle={capitalizeFirstLetter(auth?.currentUser?.displayName ?? "")}
        enableLink={true}
        buttonTitle="Exit"
        onSearch={() => {}}
        onNext={() => {}}
      />
      <div className="flex flex-col">
        <div className="my-7 flex flex-col space-y-[10px] w-full gap-4">
          <div className="px-4 flex flex-col space-y-[10px] w-full">
            <label className="block text-lg font-bold text-gray-900 dark:text-white">Name</label>
            <label className="block mb-2 text-lg">{capitalizeFirstLetter(auth?.currentUser?.displayName ?? "")}</label>
            <Button
              to="#"
              onClick={() => {
                setEditName(true);
              }}
              className="w-[56px] formsecondarybutton !border-black"
            >
              Edit
            </Button>
            <div className="hidden thinseparator md:block"></div>
          </div>

          <div className="px-4 flex flex-col space-y-[10px] w-full">
            <label className="block text-lg font-bold text-gray-900 dark:text-white">Email</label>
            <label className="block mb-2 text-lg">{auth?.currentUser?.email}</label>
            <Button
              to="#"
              onClick={() => {
                setEditEmail(true);
              }}
              className="w-[56px] formsecondarybutton !border-black"
            >
              Edit
            </Button>
            <div className="hidden thinseparator md:block"></div>
          </div>

          <div className="px-4 flex flex-col space-y-[10px] w-full">
            <label className="block text-lg font-bold text-gray-900 dark:text-white">Phone</label>
            <label className="block mb-2 text-lg">{maskedPhone}</label>
            <Button
              to="#"
              onClick={() => {
                setEditPhone(true);
              }}
              className="w-[56px] formsecondarybutton !border-black"
            >
              Edit
            </Button>
            <div className="hidden thinseparator md:block"></div>
          </div>

          <div className="px-4 flex flex-col space-y-[10px] w-full">
            <label className="block text-lg font-bold text-gray-900 dark:text-white">2 Factor Auth</label>
            <div className="flex items-center">
              <span className="bg-skgreen w-[8px] h-[8px] rounded-full"></span>
              <p className="ml-1">Active</p>
            </div>
            <div className="hidden thinseparator md:block"></div>
          </div>
          <div className="px-4 flex flex-col space-y-[10px] w-full">
            <label className="block text-lg font-bold text-gray-900 dark:text-white">Password</label>
            <label className="block mb-2 text-sm text-gray-400">Last updated Jan 12, 2024</label>
            <Button
              to="#"
              onClick={() => {
                setEditPassword(true);
              }}
              className="w-full formsecondarybutton !border-black md:max-w-[200px] md:mx-0"
            >
              Reset Password
            </Button>
            <div className="hidden thinseparator md:block"></div>
          </div>

          <div className="px-4 flex flex-col space-y-[10px] w-full">
            <label className="block mb-2 text-sm text-gray-400">
              Your account will be permanently deleted and you will not be able to recover the account.
            </label>
            <button className="px-4 w-full md:w-[200px] py-2 formsecondarybutton !text-red-600 border !border-red-600" onClick={() => {}}>
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
